module.exports = __webpack_public_path__ + "img/franchising_accomplishments_4.fb86449d.svg";